import type {
  popupInterface,
  cartInterface,
  loaderObjectInterface,
  MerchantInfoInterface,
  RequestIdData,
  ErrorMessageInterface,
  SnackbarInterface,
  paymentButtonInterface,
  offerBannerInterface,
  selectedPaymentOfferInterface,
  upiFailureAlertInterface,
  paymentProviderLevelConfigInterface,
  pspButtonsConfigInterface,
  automationDataInterface,
  shopifyCookieInfoInterface,
  experimentsInterface,
  userVariantsInterface,
  discountBasedRewardsInterface,
  LocalStorageInterface,
  PaymentsGeneralConfigInterface,
  OneClickCouponInterface,
  GSTBillingInterface,
  mergedAddressScreenInterface,
  EarnedLoyaltyInterface,
  PersistedMessageInterface,
  kpFbPixelInterface,
} from './../services/Interfaces';
import { writable, type Writable } from 'svelte/store';

//incognito check
export const store_isNotIncognito: Writable<any> = writable(false);

//requestId
export const store_requestId: Writable<string> = writable('');
export const store_cartjsObject: Writable<cartInterface> = writable(null);
export const store_originalCartjsObject: Writable<cartInterface> = writable(null);
export const store_cartId: Writable<number> = writable(null);
export const store_mid: Writable<any> = writable(null);
export const store_requestIdObject: Writable<RequestIdData> = writable(null);
export const store_lazyLoad_Otp: Writable<Boolean> = writable(false);

//mercahnt url
export const store_merchanturl: Writable<string> = writable('');

// snackbar
export const snackbar_state: Writable<SnackbarInterface> = writable({
  timeout: 0,
  open: false,
  message: '',
  type: '',
  callbackAfterTimeout: null,
});
export const common_loader: Writable<Array<loaderObjectInterface>> = writable([]);

// timer
export const store_resetTime: Writable<boolean> = writable(false);
export const store_allowReset: Writable<boolean> = writable(false);
export const store_editAddress: Writable<boolean> = writable(false);
export const store_disableContinueButton: Writable<boolean> = writable(true);
export const store_disablePaymentLink: Writable<boolean> = writable(false);
export const store_codOtpRequired: Writable<boolean> = writable(false);
export const store_foreignAnalytics: Writable<Array<string>> = writable([]);
export const store_freeShipping: Writable<boolean> = writable(false);
export const store_primary_color: Writable<string> = writable('');
export const store_screen_width: Writable<number> = writable(0);
export const store_shipping_error_flag: Writable<boolean> = writable(false);
export const store_pincode_error_flag: Writable<boolean> = writable(false);
export const store_billingAddressPincode: Writable<string> = writable('');
export const store_shipping_el: Writable<HTMLDivElement | any> = writable('');
export const store_shippingInAddressShown: Writable<boolean> = writable(false);
export const store_sourceValue: Writable<string> = writable('');
export const store_note_attributes: Writable<Array<string>> = writable([]);
export const store_shopifyAddressFound: Writable<boolean> = writable(false);
export const store_newAddressLayout: Writable<boolean> = writable(false);
export const store_merchantInfo: Writable<MerchantInfoInterface> = writable();
export const store_show_input: Writable<boolean> = writable(false);
export const store_paymentLink: Writable<string> = writable('');
export const store_upiClickCounter: Writable<number> = writable(0);
export const store_fbp: Writable<string> = writable('');
export const store_fbc: Writable<string> = writable('');
export const store_fb_external_id: Writable<string> = writable('');
export const store_channelSource: Writable<string> = writable('');
export const store_channel: Writable<string> = writable('');
export const store_pincodeRef: Writable<HTMLElement | any> = writable('');
export const store_checkMappedEmail: Writable<boolean> = writable(false);
export const store_mappedEmail: Writable<string> = writable('');
export const store_pincodeFilled: Writable<boolean> = writable(true);
export const store_discountExperimentFlag: Writable<boolean> = writable(false);
export const store_webengageCustomerId: Writable<{ id: string; triggerLogin: boolean }> = writable({
  id: '',
  triggerLogin: false,
});
export const store_otpLoader: Writable<boolean> = writable(false);

export const store_hideCashToPrepaid: Writable<boolean> = writable(false);
export const store_cashToPrepaid: Writable<boolean> = writable(false);
export const store_codThresholdValue: Writable<number> = writable(0);
export const store_cashToPrepaidConfig: Writable<boolean> = writable(false);
export const store_shopifyAddAddressCall: Writable<boolean> = writable(false);
export const store_errScreenMessage: Writable<string> = writable('');
export const store_autoSelectShippingFlag: Writable<boolean> = writable(false);
export const store_userExperiments: Writable<experimentsInterface> = writable([]);
export const store_fullScreenPopUp: Writable<popupInterface> = writable({
  showPopup: false,
  mode: null,
  component: null,
  componentData: null,
  showCloseButton: true,
  topCloseButtonPos: false,
  customClass: '',
});
export const store_isReFetchAddress: Writable<boolean> = writable(false);
export const store_paymentMethods: Writable<paymentButtonInterface[]> = writable([]);
export const store_allowedPaymentMethods: Writable<string[]> = writable([]);
export const store_paymentOfferBanner: Writable<offerBannerInterface> = writable(null);
export const store_selectedPaymentOffer: Writable<selectedPaymentOfferInterface> = writable(null);
export const store_isAutoOfferSelected: Writable<boolean> = writable(false);
export const store_iframeClose: Writable<boolean> = writable(false);
export const store_adoncLoader: Writable<boolean> = writable(false);
export const store_osType: Writable<string> = writable('other');
export const store_editPartialAddress: Writable<boolean> = writable(false);
export const store_kwikKey: Writable<string> = writable(null);
export const store_mergedAddressScreen: Writable<mergedAddressScreenInterface> = writable({
  merged: false,
  addressValid: false,
  billingAddressValid: false,
});
export const store_automationData: Writable<automationDataInterface> = writable({
  transcation_id: null,
  captcha_code: null,
  mid: null,
  request_id: null,
  gokwik_oid: null,
});

export const store_skipToPayment: Writable<{
  config: boolean;
  skip_flow: boolean;
  address_check: boolean;
  shipping_check: boolean;
  edit_address?: boolean;
  no_redirect?: boolean;
  add_address?: boolean;
  applied_discount?: boolean;
  fireEvent?: boolean;
  show_skeleton?: boolean;
}> = writable({
  config: false,
  skip_flow: false,
  address_check: false,
  shipping_check: false,
  edit_address: false,
  no_redirect: false,
  add_address: false,
  applied_discount: false,
  fireEvent: true,
  show_skeleton: false,
});

export const store_sourceUrl: Writable<string> = writable('');
export const osType = writable(getOS());
function getOS() {
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K', 'macOS'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (/Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
}

export const store_toggleBranding: Writable<boolean> = writable(true);
export const store_loader: Writable<{ message: string; status: boolean; background: boolean }> = writable({
  message: '',
  status: false,
  background: false,
});
export const store_paymentMethodFailureAlert: Writable<upiFailureAlertInterface> = writable({
  on_payment_button: false,
  on_payment_page: false,
});

export const store_paymentProviderLevelConfig: Writable<paymentProviderLevelConfigInterface> = writable({});
export const store_pspButtonsConfig: Writable<pspButtonsConfigInterface> = writable({});
export const store_shopifySessionId: Writable<string> = writable('');
export const store_actionLogs: Writable<any> = writable({});
export const store_kwikpassToken: Writable<string> = writable(null);
export const store_gaCookies: Writable<string> = writable(null);

export const store_shippingAsProduct: Writable<{ status: boolean; apply: boolean }> = writable({
  status: false,
  apply: false,
});

//CHECKOUT-4804
export const store_discountBasedRewards: Writable<discountBasedRewardsInterface> = writable({
  amount: 0,
  code: '',
  applied: false,
  autoApply: true,
  reloadMethods: false,
  type: 'OR',
  reloadShipping: false,
});
//CHECKOUT-4804
export const store_shopifyCookieInfo: Writable<shopifyCookieInfoInterface> = writable({
  landing_page: '/',
  orig_referrer: 'blank',
  sa_shopify_y: null,
  sa_localization: null,
  sa_shopify_t: null,
  sa_shopify_p: null,
  domain_userid: null,
});
export const store_pageName: Writable<string> = writable('');
export const store_hideDisabledCOD: Writable<boolean> = writable(false);
export const store_progress: Writable<number> = writable(0);

export const store_paymentsGeneralConfig: Writable<PaymentsGeneralConfigInterface> = writable({});
export const store_exsitingAddressErrorField: Writable<Array<string>> = writable([]);
export const store_country_code: Writable<string> = writable('');
export const store_giftCardProvider: Writable<string> = writable('');
export const store_emailBasedCohortDiscounts: Writable<boolean> = writable(false);
export const store_validOffersState: Writable<string> = writable('pending');
// Updated/Merged stores
export const store_localStorageObject: Writable<LocalStorageInterface> = writable({
  gkbuynow: false,
  goKwikToken: '',
  goKwikSessionId: '',
  gk_login_source: '',
});

export const store_fireEvents: Writable<{ login_complete: boolean; address_step_reached: boolean }> = writable({
  login_complete: true,
  address_step_reached: true,
});
export const store_shouldUseWebviewFallbackFlow: Writable<boolean> = writable(false);
export const store_shouldUseSameTabRedirectionFlow: Writable<boolean> = writable(false);
export const store_otpValue: Writable<string> = writable('');
export const store_savedCardEnabled: Writable<boolean> = writable(false);
export const store_geolocationMMIFlow: Writable<boolean> = writable(false);
export const store_oneClickCoupon: Writable<OneClickCouponInterface> = writable({
  is_active: false,
  type: '',
  code: '',
  auto_apply: false,
  applied: false,
  stacking_code_list: [],
});
export const store_GSTBilling: Writable<GSTBillingInterface> = writable({
  enabled: false,
  billing_address: false,
  address: '',
  gst_number: '',
  applied: false,
  name: '',
  billing_address_applied: false,
  billing_address_shown: true,
  billing_address_object: {
    address: '',
    name: '',
    city: '',
    state: '',
    pincode: '',
  },
});
export const store_addressSuggestionFlow: Writable<boolean> = writable(false);
export const store_addressOnPaymentsPage: Writable<boolean> = writable(false);
export const store_addressCount: Writable<number> = writable(0);
export const store_highlightedMessage: Writable<string> = writable('');
export const store_showCartUpdateMessage: Writable<boolean> = writable(false);

export const store_whatsappOTP: Writable<boolean> = writable(false);
export const store_additionalAddress: Writable<boolean> = writable(false);
export const store_paymentMethodsOrder: Writable<string[]> = writable([]);
export const store_loadingFlag: Writable<boolean> = writable(false);
export const store_showShipping: Writable<boolean> = writable(false);
export const store_earnedLoyaltyDetails: Writable<EarnedLoyaltyInterface> = writable({
  enabled: false,
  custom_loyalty_name: null,
  displayAmount: 0,
});
export const store_persistedErrorMessage: Writable<PersistedMessageInterface | null> = writable({
  message: '',
  page: undefined,
  bottomSheetType: '',
});
export const store_isCartUpdated: Writable<boolean> = writable(false);
export const store_fbExternalId: Writable<kpFbPixelInterface> = writable({
  kp_fb_external_id: '',
  kp_fb_cli_id: '',
  kp_user_token: '',
});
